import styled from "styled-components"

// import { FeatureCTA as CTA } from "../features/styled"
// import { BaseContainer } from "../container"
// import { devices } from "../../utils/styleVariables"
// import bgUrl from "../../images/templates-bg.svg"
import { CardContainer, CardTextContainer } from "../homeTestimonial/styled"
import { YekanParagraph } from "../typography"
import { Button } from "../inputs"

const FeatureCTA = styled(CardTextContainer)`
  text-align: center;
  margin-top: 40px;

  button {
    width: 100px;
    margin-right: auto;
    margin-left: auto;
  }
`

const Container = styled(CardContainer)`
  margin: 90px auto;

  & ${YekanParagraph} {
    margin-top: 32px;
  }
`

export { FeatureCTA, Container }
